<script lang="ts" setup>
import type { ArticleBoxType } from '~/components/article/box/ArticleBox.vue'
import type { SrcSetSizes } from '~/composables/useSrcSet'

export interface ArticleBoxThumbnailProps {
    data: BlogPost
    type: ArticleBoxType
    altSwitch: boolean 
}

const props = withDefaults(defineProps<ArticleBoxThumbnailProps>(), {
    altSwitch: true,
})
const imageSrc = computed((): SrcSetSizes | undefined =>
    useSrcSetSizes(props.data?.featured_images.path)
)
</script>
<template>
  <template v-if="props.data.featured_images?.path">
    <img
      v-if="imageSrc?.srcSet"
      :srcset="imageSrc.srcSet"
      sizes="(min-width: 768px) 33vw, (min-width: 1230px) 35rem, 100vw"
      loading="lazy"
      class="w-100 h-auto rounded-top d-block"
      :class="{
        'rounded-bottom': props.type === 'secondary',
      }"
      decoding="async"
      alt=""
      width="350"
      height="245"
    >
  </template>

  <img
    v-else
    width="370"
    height="260"
    class="d-block w-100"
    :class="{
      rounded: props.type === 'secondary',
    }"
    loading="lazy"
    decoding="async"
    alt=""
    src="~/assets/images/thumbnail.svg"
  >
</template>
